module.exports = __webpack_public_path__ + "img/1-4-p3.925ca95e.svg";